import { render, staticRenderFns } from "./DeveloperNorms.vue?vue&type=template&id=54d05bb2&scoped=true"
import script from "./DeveloperNorms.vue?vue&type=script&lang=js"
export * from "./DeveloperNorms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d05bb2",
  null
  
)

export default component.exports